function findDuplicates(numberList: string[]): string[] {
  return numberList.filter((e, i, a) => a.indexOf(e) !== i);
}

export { findDuplicates };
